import { Input } from "../../input";
import { Textarea } from "../../textarea";

import { FieldType, type FieldConfig } from "./types";

export interface OpenaiYamlFieldRendererProps {
  config: FieldConfig;
  value: string | boolean | undefined;
  readOnly?: boolean;
  onChange: (value: string | boolean) => void;
}

export const OpenaiYamlFieldRenderer = ({
  config,
  value,
  readOnly = false,
  onChange,
}: OpenaiYamlFieldRendererProps) => {
  const stringVal = typeof value === "string" ? value : "";

  switch (config.type) {
    case FieldType.Boolean:
      return (
        <div className="space-y-1">
          <label className="flex items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300"
              disabled={readOnly}
              checked={
                typeof value === "boolean" ? value : ((config.defaultValue as boolean) ?? false)
              }
              onChange={e => onChange(e.target.checked)}
            />
            <span>{config.label}</span>
          </label>
          {config.description ? <p className="ml-6 text-xs text-gray-400">{config.description}</p> : null}
        </div>
      );
    case FieldType.Textarea:
      return (
        <div className="space-y-1">
          <label className="text-sm font-medium text-gray-700">{config.label}</label>
          <Textarea
            value={stringVal}
            readOnly={readOnly}
            onChange={e => onChange(e.target.value)}
            placeholder={config.placeholder}
          />
          {config.description ? <p className="text-xs text-gray-400">{config.description}</p> : null}
        </div>
      );
    case FieldType.Text:
    case FieldType.Color:
      return (
        <div className="space-y-1">
          <label className="text-sm font-medium text-gray-700">{config.label}</label>
          <Input
            value={stringVal}
            readOnly={readOnly}
            onChange={e => onChange(e.target.value)}
            placeholder={config.placeholder}
          />
          {config.description ? <p className="text-xs text-gray-400">{config.description}</p> : null}
        </div>
      );
    default:
      return null;
  }
};
